// Filename: public/BIEventsFunctions.js 
import { biLoggerFactory } from 'wix-private';
import wixLocation from 'wix-location';

const msid = '608a942e-44d7-4abd-b6c4-dd92c457228f';

const biGroupsLoggers = {

    110: biLoggerFactory('design-features', 110, { msid }),
}

export async function fireBIEvent(src, evid, fields) {
    console.log('fireBIEvent');
    const biLogger = biGroupsLoggers[src];
    const biEventObject = {
        evid,
        ...fields
    }

    try {
        await biLogger.log(biEventObject);
        console.log('success');

    } catch (e) {
        console.log('fail');
        console.log(e, biEventObject)
    }

}